import { createContext, useContext } from "react";
import type { SessionCreationFlow } from "./types";

export const SessionCreationFlowContext = createContext<SessionCreationFlow | null>(null);

export const useSessionCreation = (): SessionCreationFlow => {
  const ctx = useContext(SessionCreationFlowContext);
  if (!ctx) {
    throw new Error("useSessionCreation must be used inside <SessionCreationFlowProvider>");
  }
  return ctx;
};
